import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

import { LoyaltyLoader } from '../loyalty-loader';

export const StyledLoyaltyLoader = LoyaltyLoader;

const styles = StyleSheet.create({
  offersCooldownContainer: {
    backgroundColor: primitive.$warningLight,
    paddingVertical: spacing.$2,
  },
  cooldownMessageContainer: {
    flexDirection: 'column',
  },
});

export const OffersCooldownContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.offersCooldownContainer, style] });

export const CooldownMessageContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.cooldownMessageContainer, style] });

export const OffersCooldownTitle = withTypography({
  variant: 'headerFour',
  fontSize: 'xs',
  mb: '$0',
});

export const OffersCooldownMessage = withTypography({ variant: 'copyTwo', fontSize: 'xs' });
